import React from "react";
import { Row, Col } from "reactstrap";
import { Helmet } from "react-helmet";
import Footer from '../../../components/Footer';
import { ArticleContent } from "../../../style/Blog";
import CardClotereSidebarQuestion from "../../CardClotereSidebarQuestion";
import HeaderPost from '../../HeaderPost';
import ArticlesSimilaires from "../../ArticlesSimilaires";
import PrendreRdv from "../../../leadPage/prendreRdv";
import FraisDeNotaireImg from "../../../img/frais-de-notaire-immobilier.png"
import CardClotere1 from "../../CardClotere1";

function CompositionFraisNotaire(args) {


    return (
        <>
            <Helmet>
                <title>Qu'est-ce que les frais de notaire en immobilier ? | Clotere</title>
                <meta name="description" content="Les frais de notaire représente une dépense non négligeable lors de votre achat immobilier. On vous explique tout sur les frais de notaire." />
                <meta property="og:url" content="https://clotere.fr/blog/documents-vente-immobiliere" />
                <meta property="og:title" content="Les frais de notaire lors d'un achat immobilier" />
                <meta property="og:description" content="Les frais de notaire représente une dépense non négligeable lors de votre achat immobilier. On vous explique tout sur les frais de notaire." />
                <meta property="og:image" content="https://clotere.fr/images/blog-vente-immo.webp" />
            </Helmet>

            <HeaderPost titre="Qu'est-ce que les frais de notaire en immobilier ?" breadlink1="/blog" namelink1="Blog" namelinkActive="Frais de notaire" />
            <ArticleContent className="bg-gradient-to-b from-transparent to-purple-50 pb-40">
                <section className="content">
                    <div className="container">
                        <Row>
                            <Col className="col-sm-9 col-xs-12 article">
                                <h2>📌 Les frais de notaire : tout ce que vous devez savoir</h2>
                                <p>Les fameux frais de notaire représentent un coût important dans votre achat immobilier. La formulation "frais de notaire" pourrait nous faire penser qu'il s'agit uniquement de la rémunération du notaire.</p>
                                <p>Mais en réalité, la rémunération du notaire ne représente qu'une faible part de ces frais.</p>

                                <h2>🔍 De quoi sont composés les frais de notaire ?</h2>
                                <img src={FraisDeNotaireImg} alt="Frais de notaire immobilier" className="sm:w-[80%] mx-auto my-4" />
                                <ul>
                                    <li><strong>Les impôts et taxes :</strong> C’est la part la plus importante (jusqu’à 6 % du prix du bien), composée des droits de mutation, taxes départementales, etc.</li>
                                    <li><strong>Les débours :</strong> Ce sont les sommes avancées par le notaire pour obtenir des documents (cadastre, urbanisme...). Ils sont remboursés par l’acheteur.</li>
                                    <li><strong>Les émoluments :</strong> Il s’agit des honoraires du notaire. Ils sont réglementés par l’État et représentent une petite part du total.</li>
                                </ul>


                                <h2>📉 Peut-on réduire les frais de notaire ?</h2>
                                <p>Les frais de notaire étant réglementés, vous n'avez que peu de possibilités de les négocier. Pour les réduire, 2 possibilités s'offrent à vous :</p>
                                <ul>
                                    <li><strong>Déduire la valeur des meubles et les frais d’agence :</strong>  Comme les frais de notaire sont calculés sur la valeur du bien, si vous déduisez certains coûts comme les frais d'agence et la valeur nette des meubles, vous obtiendrez des frais de notaire diminués..</li>
                                    <li><strong>Acheter dans le neuf :</strong> Les taxes sur l'immobilier neuf étant moins importantes, en achetant un bien neuf, vous bénéficierez de frais réduits.</li>
                                </ul>

                                <h2>🧮 Comment calculer les frais de notaire ?</h2>
                                <p>En général, les frais de notaire représentent environ 7 à 8 % du prix d'achat pour un bien ancien, et environ 2 à 3 % pour un bien neuf. Voici une petite formule simple pour vous donner une idée :</p>
                                <p>Voici une estimation des frais selon le type de bien :</p>
                                <ul>
                                    <li><strong>Bien ancien :</strong> Prix x 8 %</li>
                                    <li><strong>Bien neuf :</strong> Prix x 3 %</li>
                                </ul>
                                <p>Quelques exemples de frais de notaire :</p>
                                <blockquote className="blog-quote">Pour une maison ancienne achetée à 200 000 €, les frais de notaire seront d'environ 16 000 € (200 000 x 0,08).</blockquote>
                                <blockquote className="blog-quote">Pour un appartement neuf acheté au même prix, ils seront d'environ 6 000 € (200 000 x 0,03).</blockquote>

                                <p>Pour une estimation plus précise, vous pouvez utiliser un <a href="https://paris.notaires.fr/fr/outils-et-services/calcul-de-frais-d-achat" target="_blank" rel="noopener noreferrer">simulateur officiel</a>.</p>

                                <h2>💸 Qui paie les frais de notaire ?</h2>
                                <p>
                                    C'est toujours l'acheteur qui paie les frais de notaire. Le vendeur ne paie pas de frais de notaire.<br />

                                    Si deux notaires sont impliqués dans la transaction, un notaire pour le vendeur et un notaire pour l'acheteur, cela ne change rien, les frais de notaire ne seront pas plus élevés et seront payés par l'acheteur. Les notaires se partageront les émoluments.
                                </p>

                                <h2>📅 Quand payer ces frais ?</h2>
                                <p>Les frais de notaire sont généralement payés au moment de la signature de l'acte de vente définitif. Le notaire vous fournira un décompte détaillé de tous les frais avant la signature, afin que vous sachiez exactement ce que vous devez payer.</p>
                                <blockquote className="blog-quote">Le paiement se fait souvent par virement bancaire, juste avant ou lors de la signature.</blockquote>
                                <h2>✅ Conclusion</h2>
                                <p>
                                    Comprendre et anticiper vos frais de notaire est très utile pour mieux préparer votre budget et aborder votre achat avec sérénité. Nous vous conseillons vivement de calculer à l'avance vos frais de notaire.<br /><br />

                                    N'hésitez pas à poser toutes vos questions à votre notaire, qui est là pour vous accompagner tout au long du processus. Acheter une maison est une grande aventure, et avec un notaire compétent à vos côtés, vous pouvez avancer en toute confiance. Trouvez facilement votre notaire pour vous accompagner dans votre achat immobilier
                                </p>
                                <CardClotere1 type="achat" />
                            </Col>

                            <div className="col-sm-3 col-xs-0 sidebar hidden sm:block">
                                <CardClotereSidebarQuestion />
                            </div>

                            <div className="col-xs-0 sm:hidden">
                                <CardClotereSidebarQuestion />
                            </div>
                        </Row>
                    </div>
                </section>
            </ArticleContent>
            <ArticlesSimilaires title="Articles similaires" type="immobilier" />
                <PrendreRdv />
      <Footer />
        </>
    );
}

export default CompositionFraisNotaire;